import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Facebook } from 'assets/icons/facebook.svg';
import { ReactComponent as Instagram } from 'assets/icons/instagram.svg';
import useWindowWidth from 'hooks/useWindowWidth';
import { ROUTES } from 'routes/routes';
import LanguageSwitcher from 'components/language-switcher/LanguageSwitcher';
import './Footer.scss';
import { useI18n } from 'hooks/usei18n';

export const SOCIAL_MEDIA = {
  instagram: 'https://www.instagram.com/2kiddo.bg?igsh=MXkwbXAxcjhsOXU0Ng==',
  facebook: 'https://www.facebook.com/share/6Wg1R3zBGoMRLzZu/?mibextid=LQQJ4d'
};

const year = new Date().getFullYear();

const Footer = () => {
  const { t } = useTranslation();
  const { getLanguageUrl } = useI18n();
  const { isMobile } = useWindowWidth();

  const renderCategories = (listName: string) => {
    const { t } = useTranslation();

    return (
      <ul className="flex flex-column footer-list">
        <li className="fs-18 footer-list-category">{listName}</li>
        <li className="footer-list-item">
          <Link to={getLanguageUrl(ROUTES.AllProducts.path + '/boys')}>{t('footer.boys')}</Link>
        </li>
        <li className="footer-list-item">
          <Link to={getLanguageUrl(ROUTES.AllProducts.path + '/girls')}>{t('footer.girls')}</Link>
        </li>
        <li className="footer-list-item">
          <Link to={getLanguageUrl(ROUTES.AllProducts.path + '/twins')}>{t('footer.twins')}</Link>
        </li>
      </ul>
    );
  };

  return (
    <footer className="flex flex-column footer">
      {isMobile && <LanguageSwitcher />}
      <section className="flex space-between footer-row">
        <article className="flex footer-content">
          {renderCategories(t('footer.categories'))}
          <ul className="flex flex-column footer-list">
            <li className="fs-18 footer-list-category">{t('footer.useful')}</li>
            <li className="footer-list-item">
              <Link to={getLanguageUrl(ROUTES.Blog.path)}>{t('footer.blog')}</Link>
            </li>
            <li className="footer-list-item">
              <Link to={getLanguageUrl(ROUTES.SizesChart.path)}>{t('footer.tableWithChartSizes')}</Link>
            </li>
            <li className="footer-list-item">
              <Link to={getLanguageUrl(ROUTES.Returns.path)}>{t('footer.returnPolicy')}</Link>
            </li>
          </ul>
        </article>
        <article className="flex footer-contacts">
          <div className="flex flex-column footer-contacts-row">
            <a href="mailto:2kiddo.bg@gmail.com" className="fs-16 semi-bold">2kiddo.bg@gmail.com</a>
          </div>
          <div className="flex footer-contacts-social-media">
            <a href={SOCIAL_MEDIA.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <Instagram className="footer-contacts-social-media-icon" />
            </a>
            <a href={SOCIAL_MEDIA.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <Facebook className="footer-contacts-social-media-icon" />
            </a>
          </div>
          {!isMobile && <LanguageSwitcher />}
        </article>
      </section>
      <section className="flex space-between fs-12">
        <article className="flex align-center footer-copyright-wrapper">
          <p className="footer-copyright">{year} 2Kiddo. {t('footer.allRightsReserved')}.</p>
          <ul className="flex footer-links">
            <li className="text-underline">
              <Link to={getLanguageUrl(ROUTES.GeneralTerms.path)}>{t('footer.termsAndConditions')}</Link>
            </li>
            <li className="text-underline">
              <Link to={getLanguageUrl(ROUTES.PrivatePolicy.path)}>{t('footer.privacyPolicy')}</Link>
            </li>
            <li className="text-underline">
              <Link to={getLanguageUrl(ROUTES.CookiesPolicy.path)}>{t('footer.cookiePolicy')}</Link>
            </li>
          </ul>
        </article>
      </section>
    </footer>
  );
};

export default Footer;
